import { useEffect, useState } from "react";
import type { AttendeeSchoolLearningDisclosure } from "@verity-connect/contracts";

export function SchoolLearningDisclosureNotice({ eventSlug, signedIn }: { eventSlug: string; signedIn: boolean }) {
  const [disclosure, setDisclosure] = useState<AttendeeSchoolLearningDisclosure | null>(null);
  useEffect(() => {
    if (!signedIn) return;
    const controller = new AbortController();
    void fetch(`/api/attendee/events/${encodeURIComponent(eventSlug)}/learning-disclosure`, { credentials: "same-origin", signal: controller.signal })
      .then(async (response) => response.ok ? response.json() as Promise<AttendeeSchoolLearningDisclosure> : null)
      .then((value) => setDisclosure(value))
      .catch(() => undefined);
    return () => controller.abort();
  }, [eventSlug, signedIn]);
  if (!disclosure) return null;
  return <aside className="attendee-school-learning-disclosure" aria-label="School learning disclosure">
    <strong>What {disclosure.organizationName} will receive after the Event</strong>
    <p>{disclosure.notice}</p>
    <small>School access begins {formatDate(disclosure.releaseAt)}. Saving here does not prove attendance or credit.</small>
  </aside>;
}

function formatDate(value: string) { return new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric" }).format(new Date(value)); }
